<script>
import { mapState, mapActions } from 'vuex';
import TwTitleBar from '../../../components/TwTitleBar';

export default {
  name: 'RestechWrapper',
  components: {
    TwTitleBar,
  },
  methods: {
    ...mapActions({
      loadXmlChannels: 'restech/loadXmlChannels',
      clearState: 'restech/clearState',
    }),
  },
  computed: {
    ...mapState({
      xmlChannels: state => state.restech.xmlChannels.items,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.ski.title'), to: '', disabled: true },
        { text: 'Restech', to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
  },
  mounted() {
    if (!this.xmlChannels.length) {
      this.loadXmlChannels();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearState();
    next();
  },

};
</script>

<template>
  <v-content>
    <tw-title-bar
      title="Restech"
      :breadcrumbs="breadcrumbs">
    </tw-title-bar>
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/ski/restech/RestechWrapper.vue